__turbopack_context__.v({
  "container": "YtDSdW_container",
  "group": "YtDSdW_group",
  "heading": "YtDSdW_heading",
  "item": "YtDSdW_item",
  "itemIndicator": "YtDSdW_itemIndicator",
  "itemLabel": "YtDSdW_itemLabel",
});
